// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import Navbar from "../Navbar/Navbar";
// import Footer from "../Footer/Footer";
// import { FiCheckCircle } from "react-icons/fi";
// import "./ServicePage.css";

// const ServicePage = () => {
//   const { "*" : path } = useParams();   // <-- important
//   const [service, setService] = useState(null);

//   const slug = path.split("/").pop();
//   const formattedMenuName = slug.replace(/-/g, " ").toUpperCase();

//   useEffect(() => {
//     fetch("https://api.info-sight.net/api/services")
//       .then(res => res.json())
//       .then(data => {
// const allowedPartial = ["ICT"]; // add more when needed

// const matched = data.find(item => {
//     const menu = item.menu_name.toUpperCase();
//     const head = item.heading.toUpperCase();

//     // EXACT MATCH ALWAYS FIRST
//     if (menu === formattedMenuName) return true;
//     if (head === formattedMenuName) return true;

//     // ALLOWED PARTIAL MATCH ONLY FOR SPECIAL CASES
//     if (allowedPartial.includes(formattedMenuName)) {
//         return head.includes(formattedMenuName);
//     }

//     return false; // NO MORE PART MATCHING
// });



//         setService(matched);
//       });
//   }, [formattedMenuName]);   // <-- dependency fixed

//   if (!service) return <p className="loading-text">Loading...</p>;

//   return (
//     <>
//       <Navbar />

//       <section
//         className="service-hero"
//         style={{ backgroundImage: `url(${service.image})` }}
//       >
//         <div className="service-hero-overlay" />
//         <div className="service-hero-content">
//           <h1>{service.heading}</h1>
//           <p>
//             <a href="/">Home</a> / {service.heading}
//           </p>
//         </div>
//       </section>

//       <div className="service-container">
//         <div className="service-content">
//           <h2 className="service-heading">{service.heading}</h2>
//           <p className="service-paragraph">{service.paragraph}</p>

//           {service.bullet_points && (
//             <ul className="service-bullet-list">
//               {JSON.parse(service.bullet_points).map((bullet, index) => (
//                 <li key={index} className="service-bullet-item">
//                   <FiCheckCircle className="bullet-icon" />
//                   {bullet.replace(/^•\s*/g, "")}
//                 </li>
//               ))}
//             </ul>
//           )}
//         </div>
//       </div>

//       <Footer />
//     </>
//   );
// };

// export default ServicePage;




// import React, { useEffect, useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import Navbar from "../Navbar/Navbar";
// import Footer from "../Footer/Footer";
// import {
//   FiCheckCircle,
//   FiChevronRight,
//   FiArrowRight,
//   FiPhoneCall,
//   FiLayers,
//   FiShield,
//   FiFileText,
// } from "react-icons/fi";

// // Eye-Comfort High-End Real Estate & Architectural Palette
// const theme = {
//   bgApp: "#F8FAF9",
//   bgCard: "#FFFFFF",
//   bgSubtle: "#F1F5F9",
//   primary: "#0F172A", // Deep Slate Navy
//   accent: "#0D9488", // Soft Emerald Teal
//   accentLight: "#CCFBF1",
//   accentHover: "#0F766E",
//   gold: "#D97706", // Muted Architectural Gold
//   textDark: "#1E293B",
//   textMuted: "#64748B",
//   border: "#E2E8F0",
//   shadowSm: "0 1px 3px rgba(0, 0, 0, 0.05)",
//   shadowMd: "0 10px 25px -5px rgba(0, 0, 0, 0.05), 0 8px 10px -6px rgba(0, 0, 0, 0.01)",
//   shadowLg: "0 20px 25px -5px rgba(0, 0, 0, 0.08), 0 10px 10px -5px rgba(0, 0, 0, 0.02)",
// };

// // Global Responsive Injection
// const inlineStyles = `
//   .service-page-wrapper {
//     background-color: ${theme.bgApp};
//     color: ${theme.textDark};
//     font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
//     min-height: 100vh;
//   }

//   /* Hero Section */
//   .service-hero-banner {
//     position: relative;
//     height: 380px;
//     background-size: cover;
//     background-position: center;
//     display: flex;
//     align-items: flex-end;
//   }

//   .service-hero-overlay {
//     position: absolute;
//     inset: 0;
//     background: linear-gradient(180deg, rgba(15, 23, 42, 0.3) 0%, rgba(15, 23, 42, 0.88) 100%);
//     display: flex;
//     flex-direction: column;
//     justify-content: flex-end;
//     padding: 40px 20px;
//   }

//   /* Main Layout Split */
//   .service-main-layout {
//     display: grid;
//     grid-template-columns: 1fr 340px;
//     gap: 36px;
//     max-width: 1240px;
//     margin: 40px auto 60px;
//     padding: 0 20px;
//   }

//   /* Main Article Body */
//   .service-article-card {
//     background-color: ${theme.bgCard};
//     border-radius: 20px;
//     padding: 40px;
//     border: 1px solid ${theme.border};
//     box-shadow: ${theme.shadowSm};
//   }

//   /* Bullet Grid */
//   .service-bullets-grid {
//     display: grid;
//     grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
//     gap: 16px;
//     margin-top: 24px;
//   }

//   .service-bullet-card {
//     background-color: ${theme.bgSubtle};
//     border: 1px solid ${theme.border};
//     border-radius: 12px;
//     padding: 16px 20px;
//     display: flex;
//     align-items: flex-start;
//     gap: 12px;
//     transition: transform 0.2s ease, border-color 0.2s ease;
//   }

//   .service-bullet-card:hover {
//     transform: translateY(-2px);
//     border-color: ${theme.accent};
//   }

//   /* Sidebar Cards */
//   .sidebar-card-box {
//     background-color: ${theme.bgCard};
//     border-radius: 16px;
//     padding: 28px;
//     border: 1px solid ${theme.border};
//     box-shadow: ${theme.shadowSm};
//     margin-bottom: 24px;
//   }

//   .sidebar-cta-card {
//     background: linear-gradient(135deg, ${theme.primary} 0%, #1E293B 100%);
//     color: #FFFFFF;
//     border-radius: 16px;
//     padding: 28px;
//     box-shadow: ${theme.shadowMd};
//   }

//   @media (max-width: 992px) {
//     .service-main-layout {
//       grid-template-columns: 1fr;
//     }
//   }

//   @media (max-width: 600px) {
//     .service-hero-banner {
//       height: 280px;
//     }
//     .service-article-card {
//       padding: 24px;
//     }
//     .service-bullets-grid {
//       grid-template-columns: 1fr;
//     }
//   }
// `;

// const ServicePage = () => {
//   const { "*": path } = useParams();
//   const navigate = useNavigate();
//   const [service, setService] = useState(null);
//   const [loading, setLoading] = useState(true);

//   const slug = (path || "").split("/").pop();
//   const formattedMenuName = slug.replace(/-/g, " ").toUpperCase();

//   useEffect(() => {
//     setLoading(true);
//     fetch("https://api.info-sight.net/api/services")
//       .then((res) => res.json())
//       .then((data) => {
//         const allowedPartial = ["ICT"];

//         const matched = data.find((item) => {
//           const menu = (item.menu_name || "").toUpperCase();
//           const head = (item.heading || "").toUpperCase();

//           if (menu === formattedMenuName) return true;
//           if (head === formattedMenuName) return true;

//           if (allowedPartial.includes(formattedMenuName)) {
//             return head.includes(formattedMenuName);
//           }

//           return false;
//         });

//         setService(matched || null);
//         setLoading(false);
//       })
//       .catch((err) => {
//         console.error("Error loading service data:", err);
//         setLoading(false);
//       });
//   }, [formattedMenuName]);

//   // Safe bullet point array parser
//   const getParsedBullets = (bulletData) => {
//     if (!bulletData) return [];
//     try {
//       if (Array.isArray(bulletData)) return bulletData;
//       const parsed = JSON.parse(bulletData);
//       return Array.isArray(parsed) ? parsed : [];
//     } catch {
//       return typeof bulletData === "string"
//         ? bulletData.split("\n").filter((b) => b.trim().length > 0)
//         : [];
//     }
//   };

//   if (loading) {
//     return (
//       <div className="service-page-wrapper">
//         <Navbar />
//         <div style={{ padding: "120px 20px", textAlign: "center", color: theme.textMuted }}>
//           <div
//             style={{
//               width: "40px",
//               height: "40px",
//               border: `3px solid ${theme.border}`,
//               borderTopColor: theme.accent,
//               borderRadius: "50%",
//               animation: "spin 0.8s linear infinite",
//               margin: "0 auto 16px",
//             }}
//           />
//           <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
//           <p style={{ fontSize: "1rem", fontWeight: "500" }}>Loading service specifications...</p>
//         </div>
//         <Footer />
//       </div>
//     );
//   }

//   if (!service) {
//     return (
//       <div className="service-page-wrapper">
//         <Navbar />
//         <div style={{ padding: "120px 20px", textAlign: "center", maxWidth: "600px", margin: "0 auto" }}>
//           <FiFileText size={48} color={theme.textMuted} style={{ marginBottom: "16px" }} />
//           <h2 style={{ fontSize: "1.5rem", fontWeight: "700", color: theme.primary }}>
//             Service Specification Not Found
//           </h2>
//           <p style={{ color: theme.textMuted, margin: "12px 0 24px" }}>
//             The requested service details could not be retrieved. Please check the menu link or return home.
//           </p>
//           <button
//             onClick={() => navigate("/")}
//             style={{
//               backgroundColor: theme.accent,
//               color: "#FFF",
//               border: "none",
//               padding: "12px 24px",
//               borderRadius: "8px",
//               fontWeight: "600",
//               cursor: "pointer",
//             }}
//           >
//             Return to Homepage
//           </button>
//         </div>
//         <Footer />
//       </div>
//     );
//   }

//   const bulletList = getParsedBullets(service.bullet_points);

//   return (
//     <div className="service-page-wrapper">
//       <style>{inlineStyles}</style>
//       <Navbar />

//       {/* Hero Banner Section */}
//       <section
//         className="service-hero-banner"
//         style={{ backgroundImage: `url(${service.image})` }}
//       >
//         <div className="service-hero-overlay">
//           <div style={{ maxWidth: "1240px", width: "100%", margin: "0 auto" }}>
//             {/* Breadcrumb Navigation */}
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: "8px",
//                 color: "rgba(255,255,255,0.8)",
//                 fontSize: "0.85rem",
//                 marginBottom: "12px",
//               }}
//             >
//               <span style={{ cursor: "pointer" }} onClick={() => navigate("/")}>
//                 Home
//               </span>
//               <FiChevronRight size={12} />
//               <span style={{ cursor: "pointer" }} onClick={() => navigate("/#services")}>
//                 Services
//               </span>
//               <FiChevronRight size={12} />
//               <span style={{ color: theme.accentLight, fontWeight: "600" }}>
//                 {service.heading}
//               </span>
//             </div>

//             <h1
//               style={{
//                 color: "#FFFFFF",
//                 fontSize: "2.25rem",
//                 fontWeight: "800",
//                 lineHeight: "1.2",
//               }}
//             >
//               {service.heading}
//             </h1>
//           </div>
//         </div>
//       </section>

//       {/* Main Content Split Layout */}
//       <div className="service-main-layout">
//         {/* Left Primary Content Article */}
//         <article className="service-article-card">
//           <span
//             style={{
//               color: theme.accent,
//               fontWeight: "600",
//               fontSize: "0.825rem",
//               letterSpacing: "1.2px",
//               textTransform: "uppercase",
//               backgroundColor: theme.accentLight,
//               padding: "6px 14px",
//               borderRadius: "20px",
//               display: "inline-block",
//               marginBottom: "16px",
//             }}
//           >
//             Engineering Deliverables
//           </span>

//           <h2
//             style={{
//               fontSize: "1.75rem",
//               fontWeight: "800",
//               color: theme.primary,
//               marginBottom: "20px",
//               lineHeight: "1.3",
//             }}
//           >
//             {service.heading}
//           </h2>

//           <p
//             style={{
//               color: theme.textMuted,
//               fontSize: "1.025rem",
//               lineHeight: "1.75",
//               marginBottom: "32px",
//               whiteSpace: "pre-line",
//             }}
//           >
//             {service.paragraph}
//           </p>

//           {/* Bullet Deliverables Section */}
//           {bulletList.length > 0 && (
//             <div style={{ paddingTop: "24px", borderTop: `1px solid ${theme.border}` }}>
//               <h3
//                 style={{
//                   fontSize: "1.2rem",
//                   fontWeight: "700",
//                   color: theme.primary,
//                   marginBottom: "16px",
//                 }}
//               >
//                 Key Scope & Technical Capabilities
//               </h3>

//               <div className="service-bullets-grid">
//                 {bulletList.map((bullet, index) => {
//                   const cleanedText = bullet.replace(/^•\s*/g, "");
//                   return (
//                     <div key={index} className="service-bullet-card">
//                       <FiCheckCircle
//                         size={20}
//                         color={theme.accent}
//                         style={{ flexShrink: 0, marginTop: "2px" }}
//                       />
//                       <span
//                         style={{
//                           fontSize: "0.925rem",
//                           color: theme.textDark,
//                           fontWeight: "500",
//                           lineHeight: "1.5",
//                         }}
//                       >
//                         {cleanedText}
//                       </span>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           )}
//         </article>

//         {/* Right Sidebar Controls */}
//         <aside>
//           {/* Executive Overview Box */}
//           <div className="sidebar-card-box">
//             <h3
//               style={{
//                 fontSize: "1.1rem",
//                 fontWeight: "700",
//                 color: theme.primary,
//                 marginBottom: "16px",
//                 display: "flex",
//                 alignItems: "center",
//                 gap: "8px",
//               }}
//             >
//               <FiLayers color={theme.accent} /> Service Overview
//             </h3>

//             <div
//               style={{
//                 display: "flex",
//                 flexDirection: "column",
//                 gap: "12px",
//                 fontSize: "0.9rem",
//                 color: theme.textMuted,
//               }}
//             >
//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   paddingBottom: "10px",
//                   borderBottom: `1px solid ${theme.border}`,
//                 }}
//               >
//                 <span>Category</span>
//                 <strong style={{ color: theme.primary }}>{service.menu_name || "Consulting"}</strong>
//               </div>

//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   paddingBottom: "10px",
//                   borderBottom: `1px solid ${theme.border}`,
//                 }}
//               >
//                 <span>Standard Compliance</span>
//                 <strong style={{ color: theme.primary }}>Global Standards</strong>
//               </div>

//               <div style={{ display: "flex", justifyContent: "space-between" }}>
//                 <span>Execution Scope</span>
//                 <strong style={{ color: theme.primary }}>Concept to Delivery</strong>
//               </div>
//             </div>
//           </div>

//           {/* Consultation CTA Banner */}
//           <div className="sidebar-cta-card">
//             <span
//               style={{
//                 fontSize: "0.75rem",
//                 color: theme.accentLight,
//                 fontWeight: "600",
//                 textTransform: "uppercase",
//                 letterSpacing: "1px",
//               }}
//             >
//               Expert Consultation
//             </span>
//             <h4
//               style={{
//                 fontSize: "1.25rem",
//                 fontWeight: "700",
//                 color: "#FFFFFF",
//                 margin: "8px 0 12px",
//                 lineHeight: "1.3",
//               }}
//             >
//               Discuss Your Project Requirements
//             </h4>
//             <p
//               style={{
//                 fontSize: "0.875rem",
//                 color: "rgba(255, 255, 255, 0.8)",
//                 lineHeight: "1.5",
//                 marginBottom: "20px",
//               }}
//             >
//               Connect with our specialized engineering team for technical evaluations and design inputs.
//             </p>

//             <button
//               onClick={() => navigate("/contact")}
//               style={{
//                 width: "100%",
//                 backgroundColor: theme.accent,
//                 color: "#FFFFFF",
//                 border: "none",
//                 padding: "12px",
//                 borderRadius: "8px",
//                 fontWeight: "600",
//                 fontSize: "0.9rem",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 gap: "8px",
//                 cursor: "pointer",
//                 transition: "background-color 0.2s ease",
//               }}
//             >
//               Contact Consultants <FiArrowRight size={14} />
//             </button>
//           </div>
//         </aside>
//       </div>

//       <Footer />
//     </div>
//   );
// };

// export default ServicePage;



// import React, { useEffect, useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import Navbar from "../Navbar/Navbar";
// import Footer from "../Footer/Footer";
// import {
//   FiCheckCircle,
//   FiChevronRight,
//   FiArrowRight,
//   FiLayers,
//   FiFileText,
// } from "react-icons/fi";

// const theme = {
//   bgApp: "#F8FAF9",
//   bgCard: "#FFFFFF",
//   bgSubtle: "#F1F5F9",
//   primary: "#0F172A",
//   accent: "#0D9488",
//   accentLight: "#CCFBF1",
//   accentHover: "#0F766E",
//   gold: "#D97706",
//   textDark: "#1E293B",
//   textMuted: "#64748B",
//   border: "#E2E8F0",
//   shadowSm: "0 1px 3px rgba(0, 0, 0, 0.05)",
//   shadowMd: "0 10px 25px -5px rgba(0, 0, 0, 0.05), 0 8px 10px -6px rgba(0, 0, 0, 0.01)",
//   shadowLg: "0 20px 25px -5px rgba(0, 0, 0, 0.08), 0 10px 10px -5px rgba(0, 0, 0, 0.02)",
// };

// const inlineStyles = `
//   .service-page-wrapper {
//     background-color: ${theme.bgApp};
//     color: ${theme.textDark};
//     font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
//     min-height: 100vh;
//   }
//   .service-hero-banner {
//     position: relative;
//     height: 380px;
//     background-size: cover;
//     background-position: center;
//     display: flex;
//     align-items: flex-end;
//   }
//   .service-hero-overlay {
//     position: absolute;
//     inset: 0;
//     background: linear-gradient(180deg, rgba(15, 23, 42, 0.3) 0%, rgba(15, 23, 42, 0.88) 100%);
//     display: flex;
//     flex-direction: column;
//     justify-content: flex-end;
//     padding: 40px 20px;
//   }
//   .service-main-layout {
//     display: grid;
//     grid-template-columns: 1fr 340px;
//     gap: 36px;
//     max-width: 1240px;
//     margin: 40px auto 60px;
//     padding: 0 20px;
//   }
//   .service-article-card {
//     background-color: ${theme.bgCard};
//     border-radius: 20px;
//     padding: 40px;
//     border: 1px solid ${theme.border};
//     box-shadow: ${theme.shadowSm};
//   }
//   .service-bullets-grid {
//     display: grid;
//     grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
//     gap: 16px;
//     margin-top: 24px;
//   }
//   .service-bullet-card {
//     background-color: ${theme.bgSubtle};
//     border: 1px solid ${theme.border};
//     border-radius: 12px;
//     padding: 16px 20px;
//     display: flex;
//     align-items: flex-start;
//     gap: 12px;
//     transition: transform 0.2s ease, border-color 0.2s ease;
//   }
//   .service-bullet-card:hover {
//     transform: translateY(-2px);
//     border-color: ${theme.accent};
//   }
//   .sidebar-card-box {
//     background-color: ${theme.bgCard};
//     border-radius: 16px;
//     padding: 28px;
//     border: 1px solid ${theme.border};
//     box-shadow: ${theme.shadowSm};
//     margin-bottom: 24px;
//   }
//   .sidebar-cta-card {
//     background: linear-gradient(135deg, ${theme.primary} 0%, #1E293B 100%);
//     color: #FFFFFF;
//     border-radius: 16px;
//     padding: 28px;
//     box-shadow: ${theme.shadowMd};
//   }
//   @media (max-width: 992px) {
//     .service-main-layout {
//       grid-template-columns: 1fr;
//     }
//   }
//   @media (max-width: 600px) {
//     .service-hero-banner {
//       height: 280px;
//     }
//     .service-article-card {
//       padding: 24px;
//     }
//     .service-bullets-grid {
//       grid-template-columns: 1fr;
//     }
//   }
// `;

// // Master list of all bolded keywords and phrases from the Word document
// const BOLD_TERMS = [
//   // Acoustics & Noise
//   "Building Acoustics services",
//   "environmental noise, internal ambient noise, airborne and impact sound insulation, and room acoustic comfort",
//   "environmental noise, internal ambient noise, airborne",
//   "and impact sound insulation, and room acoustic comfort",
//   "acoustic design",
//   "onsite measurements",
//   "3D acoustic simulations",
//   "MEP systems",
//   "tailored acoustic solutions",
//   "Environmental noise analysis",
//   "Internal ambient noise criteria development",
//   "Airborne noise isolation strategies",
//   "Impact insulation evaluation",
//   "Room acoustic comfort design",
//   "flanking noise transmission paths",
//   "Targeted acoustic control measures",
//   "sound transmission control strategies",

//   // Security & SRA
//   "security design solutions",
//   "security landscape",
//   "security audits",
//   "asset identification",
//   "vulnerability assessments",
//   "targeted security strategy",
//   "advanced security architectures",
//   "external factors",
//   "future-ready security environments",
//   "Security Risk and Threat Assessment (SRA)",
//   "vulnerabilities, and threat exposures",
//   "operational impacts",
//   "risk mitigation strategy",
//   "structured security plan",
//   "Comprehensive security audits",
//   "CCTV surveillance systems",
//   "access control systems",
//   "Perimeter security system design",
//   "Intrusion detection system planning",
//   "Hostile Vehicle Mitigation (HVM)",
//   "Security Management Systems (SMS)",
//   "Physical Security Information Management (PSIM)",

//   // ICT & Automation
//   "ICT communication network",
//   "smart automation",
//   "Structured Cabling Systems",
//   "Data Centre & Telecom Infrastructure",
//   "Wireless Networks (WIFI)",
//   "Networking & Active Equipment",
//   "Data Networking",
//   "Advanced IP Telephony",
//   "Smart Entertainment & Automation",

//   // IBMS & AV
//   "Integrated Building Management System (IBMS)",
//   "Audio Visual (AV)",
//   "integrated AV ecosystems",
//   "display solutions",
//   "acoustic and visual engineering",

//   // Green Building & Project Management
//   "Sustainability Assessments",
//   "Green Building Rating Strategies",
//   "Resource Optimization & Environmental Planning",
//   "Wellbeing, Decarbonization & ESG Compliance",
//   "ELV project management services",
//   "absolute synergy",
//   "Strategic Consultancy & Client Advocacy",
//   "Comprehensive Technical Project Management",
//   "Carbon Footprint Assessments",
//   "Environmental, Social, and Governance (ESG)"
// ].sort((a, b) => b.length - a.length); // Match longest phrases first

// // Helper: Matches all exact bolded phrases and inline prefixes
// const renderHighlightedText = (text) => {
//   if (!text) return "";

//   // 1. If line contains "Prefix: Rest", bold the prefix
//   const colonIndex = text.indexOf(":");
//   if (colonIndex > 0 && colonIndex < 45 && !text.includes("http")) {
//     const boldPrefix = text.slice(0, colonIndex + 1);
//     const rest = text.slice(colonIndex + 1);
//     return (
//       <>
//         <strong style={{ color: theme.primary, fontWeight: 700 }}>
//           {boldPrefix}
//         </strong>
//         {renderHighlightedText(rest)}
//       </>
//     );
//   }

//   // 2. Build regex pattern for all bold terms
//   const escapedTerms = BOLD_TERMS.map((term) =>
//     term.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&")
//   );
//   const regex = new RegExp(`(${escapedTerms.join("|")})`, "gi");
//   const parts = text.split(regex);

//   return parts.map((part, i) => {
//     const isMatched = BOLD_TERMS.some(
//       (term) => term.toLowerCase() === (part || "").toLowerCase()
//     );

//     if (isMatched) {
//       return (
//         <strong key={i} style={{ color: theme.primary, fontWeight: 700 }}>
//           {part}
//         </strong>
//       );
//     }
//     return part;
//   });
// };

// // Helper: Distinguishes Section Headings from Body Paragraphs
// const renderParagraphContent = (paragraphData) => {
//   if (!paragraphData) return null;

//   const lines = paragraphData
//     .split(/\r?\n/)
//     .map((l) => l.trim())
//     .filter((l) => l.length > 0);

//   return lines.map((line, index) => {
//     // Standalone headings from document
//     const isHeading =
//       (line.length < 75 && !line.endsWith(".") && !line.endsWith(",")) ||
//       line.endsWith(":");

//     if (isHeading) {
//       return (
//         <h4
//           key={index}
//           style={{
//             fontSize: "1.2rem",
//             fontWeight: 800,
//             color: theme.primary,
//             marginTop: index === 0 ? "0px" : "32px",
//             marginBottom: "12px",
//             lineHeight: "1.4",
//             borderLeft: `3px solid ${theme.accent}`,
//             paddingLeft: "10px",
//           }}
//         >
//           {line.replace(/:$/, "")}
//         </h4>
//       );
//     }

//     return (
//       <p
//         key={index}
//         style={{
//           color: theme.textMuted,
//           fontSize: "1.025rem",
//           lineHeight: "1.75",
//           marginBottom: "18px",
//         }}
//       >
//         {renderHighlightedText(line)}
//       </p>
//     );
//   });
// };

// const ServicePage = () => {
//   const { "*": path } = useParams();
//   const navigate = useNavigate();
//   const [service, setService] = useState(null);
//   const [loading, setLoading] = useState(true);

//   const slug = (path || "").split("/").pop();
//   const formattedMenuName = slug.replace(/-/g, " ").toUpperCase();

//   useEffect(() => {
//     setLoading(true);
//     fetch("https://api.info-sight.net/api/services")
//       .then((res) => res.json())
//       .then((data) => {
//         const allowedPartial = ["ICT"];

//         const matched = data.find((item) => {
//           const menu = (item.menu_name || "").toUpperCase();
//           const head = (item.heading || "").toUpperCase();

//           if (menu === formattedMenuName) return true;
//           if (head === formattedMenuName) return true;

//           if (allowedPartial.includes(formattedMenuName)) {
//             return head.includes(formattedMenuName);
//           }

//           return false;
//         });
// console.log('this is matched',matched)
//         setService(matched || null);
//         setLoading(false);
//       })
//       .catch((err) => {
//         console.error("Error loading service data:", err);
//         setLoading(false);
//       });
//   }, [formattedMenuName]);

//   const getParsedBullets = (bulletData) => {
//     if (!bulletData) return [];
//     try {
//       if (Array.isArray(bulletData)) return bulletData;
//       const parsed = JSON.parse(bulletData);
//       return Array.isArray(parsed) ? parsed : [];
//     } catch {
//       return typeof bulletData === "string"
//         ? bulletData.split("\n").filter((b) => b.trim().length > 0)
//         : [];
//     }
//   };

//   if (loading) {
//     return (
//       <div className="service-page-wrapper">
//         <Navbar />
//         <div style={{ padding: "120px 20px", textAlign: "center", color: theme.textMuted }}>
//           <div
//             style={{
//               width: "40px",
//               height: "40px",
//               border: `3px solid ${theme.border}`,
//               borderTopColor: theme.accent,
//               borderRadius: "50%",
//               animation: "spin 0.8s linear infinite",
//               margin: "0 auto 16px",
//             }}
//           />
//           <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
//           <p style={{ fontSize: "1rem", fontWeight: "500" }}>Loading service specifications...</p>
//         </div>
//         <Footer />
//       </div>
//     );
//   }

//   if (!service) {
//     return (
//       <div className="service-page-wrapper">
//         <Navbar />
//         <div style={{ padding: "120px 20px", textAlign: "center", maxWidth: "600px", margin: "0 auto" }}>
//           <FiFileText size={48} color={theme.textMuted} style={{ marginBottom: "16px" }} />
//           <h2 style={{ fontSize: "1.5rem", fontWeight: "700", color: theme.primary }}>
//             Service Specification Not Found
//           </h2>
//           <p style={{ color: theme.textMuted, margin: "12px 0 24px" }}>
//             The requested service details could not be retrieved. Please check the menu link or return home.
//           </p>
//           <button
//             onClick={() => navigate("/")}
//             style={{
//               backgroundColor: theme.accent,
//               color: "#FFF",
//               border: "none",
//               padding: "12px 24px",
//               borderRadius: "8px",
//               fontWeight: "600",
//               cursor: "pointer",
//             }}
//           >
//             Return to Homepage
//           </button>
//         </div>
//         <Footer />
//       </div>
//     );
//   }

//   const rawBullets = getParsedBullets(service.bullet_points);

//   return (
//     <div className="service-page-wrapper">
//       <style>{inlineStyles}</style>
//       <Navbar />

//       {/* Hero Banner Section */}
//       <section
//         className="service-hero-banner"
//         style={{ backgroundImage: `url(${service.image})` }}
//       >
//         <div className="service-hero-overlay">
//           <div style={{ maxWidth: "1240px", width: "100%", margin: "0 auto" }}>
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: "8px",
//                 color: "rgba(255,255,255,0.8)",
//                 fontSize: "0.85rem",
//                 marginBottom: "12px",
//               }}
//             >
//               <span style={{ cursor: "pointer" }} onClick={() => navigate("/")}>
//                 Home
//               </span>
//               <FiChevronRight size={12} />
//               <span style={{ cursor: "pointer" }} onClick={() => navigate("/#services")}>
//                 Services
//               </span>
//               <FiChevronRight size={12} />
//               <span style={{ color: theme.accentLight, fontWeight: "600" }}>
//                 {service.heading}
//               </span>
//             </div>

//             <h1
//               style={{
//                 color: "#FFFFFF",
//                 fontSize: "2.25rem",
//                 fontWeight: "800",
//                 lineHeight: "1.2",
//               }}
//             >
//               {service.heading}
//             </h1>
//           </div>
//         </div>
//       </section>

//       {/* Main Content Split Layout */}
//       <div className="service-main-layout">
//         {/* Left Article Body */}
//         <article className="service-article-card">
//           <span
//             style={{
//               color: theme.accent,
//               fontWeight: "600",
//               fontSize: "0.825rem",
//               letterSpacing: "1.2px",
//               textTransform: "uppercase",
//               backgroundColor: theme.accentLight,
//               padding: "6px 14px",
//               borderRadius: "20px",
//               display: "inline-block",
//               marginBottom: "16px",
//             }}
//           >
//             Engineering Deliverables
//           </span>

//           <h2
//             style={{
//               fontSize: "1.75rem",
//               fontWeight: "800",
//               color: theme.primary,
//               marginBottom: "24px",
//               lineHeight: "1.3",
//             }}
//           >
//             {service.heading}
//           </h2>

//           {/* Formatted Paragraphs, Headings, and Inline Bold Terms */}
//           <div style={{ marginBottom: "32px" }}>
//             {renderParagraphContent(service.paragraph)}
//           </div>

//           {/* Bullet Deliverables Section */}
//           {rawBullets.length > 0 && (
//             <div style={{ paddingTop: "24px", borderTop: `1px solid ${theme.border}` }}>
//               <h3
//                 style={{
//                   fontSize: "1.2rem",
//                   fontWeight: "700",
//                   color: theme.primary,
//                   marginBottom: "16px",
//                 }}
//               >
//                 Key Scope & Technical Capabilities
//               </h3>

//               <div className="service-bullets-grid">
//                 {rawBullets.map((item, index) => {
//                   const cleanedText = item.replace(/^[•\t\s*]+/g, "").trim();

//                   // Subheadings inside bullet lists
//                   const isInnerHeading =
//                     !item.startsWith("•") &&
//                     !item.startsWith("\t") &&
//                     cleanedText.length < 60 &&
//                     !cleanedText.endsWith(".");

//                   if (isInnerHeading) {
//                     return (
//                       <div
//                         key={index}
//                         style={{
//                           gridColumn: "1 / -1",
//                           marginTop: "16px",
//                           marginBottom: "4px",
//                         }}
//                       >
//                         <h4
//                           style={{
//                             fontSize: "1.1rem",
//                             fontWeight: "800",
//                             color: theme.primary,
//                           }}
//                         >
//                           {cleanedText}
//                         </h4>
//                       </div>
//                     );
//                   }

//                   return (
//                     <div key={index} className="service-bullet-card">
//                       <FiCheckCircle
//                         size={20}
//                         color={theme.accent}
//                         style={{ flexShrink: 0, marginTop: "2px" }}
//                       />
//                       <span
//                         style={{
//                           fontSize: "0.925rem",
//                           color: theme.textDark,
//                           fontWeight: "500",
//                           lineHeight: "1.5",
//                         }}
//                       >
//                         {renderHighlightedText(cleanedText)}
//                       </span>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           )}
//         </article>

//         {/* Right Sidebar Controls */}
//         <aside>
//           <div className="sidebar-card-box">
//             <h3
//               style={{
//                 fontSize: "1.1rem",
//                 fontWeight: "700",
//                 color: theme.primary,
//                 marginBottom: "16px",
//                 display: "flex",
//                 alignItems: "center",
//                 gap: "8px",
//               }}
//             >
//               <FiLayers color={theme.accent} /> Service Overview
//             </h3>

//             {/* <div
//               style={{
//                 display: "flex",
//                 flexDirection: "column",
//                 gap: "22px",
//                 fontSize: "0.9rem",
//                 color: theme.textMuted,
//               }}
//             >
//               <div
//                 style={{
//                   // display: "flex",
//                   justifyContent: "space-between",
//                   paddingBottom: "10px",
//                   borderBottom: `1px solid ${theme.border}`,
//                 }}
//               >
//                 <span>Category</span>
//                 <strong style={{ color: theme.primary}}>{service.menu_name_ || "Consulting"}</strong>
//               </div>

//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   paddingBottom: "10px",
//                   borderBottom: `1px solid ${theme.border}`,
//                 }}
//               >
//                 <span>Standard Compliance</span>
//                 <strong style={{ color: theme.primary }}>Global Standards</strong>
//               </div>

//               <div style={{ display: "flex", justifyContent: "space-between" }}>
//                 <span>Execution Scope</span>
//                 <strong style={{ color: theme.primary }}>Concept to Delivery</strong>
//               </div>
//             </div> */}

//             <div
//   style={{
//     display: "flex",
//     flexDirection: "column",
//     gap: "22px",
//     fontSize: "0.9rem",
//     color: theme.textMuted,
//   }}
// >
//   {/* Category Row */}
//   <div
//     style={{
//       display: "flex",
//       justifyContent: "space-between",
//       alignItems: "flex-start",
//       gap: "16px",
//       paddingBottom: "10px",
//       borderBottom: `1px solid ${theme.border}`,
//     }}
//   >
//     <span style={{ flexShrink: 0 }}>Category</span>
//     <strong
//       style={{
//         color: theme.primary,
//         textAlign: "right",
//         wordBreak: "break-word",
//       }}
//     >
//       {service.menu_name_ || "LEED, BREEAM, ESTIDAMA, MOSTADAM, WELL"}
//     </strong>
//   </div>

//   {/* Standard Compliance Row */}
//   <div
//     style={{
//       display: "flex",
//       justifyContent: "space-between",
//       alignItems: "flex-start",
//       gap: "16px",
//       paddingBottom: "10px",
//       borderBottom: `1px solid ${theme.border}`,
//     }}
//   >
//     <span style={{ flexShrink: 0 }}>Standard Compliance</span>
//     <strong
//       style={{
//         color: theme.primary,
//         textAlign: "right",
//         wordBreak: "break-word",
//       }}
//     >
//       Global Standards
//     </strong>
//   </div>

//   {/* Execution Scope Row */}
//   <div
//     style={{
//       display: "flex",
//       justifyContent: "space-between",
//       alignItems: "flex-start",
//       gap: "16px",
//     }}
//   >
//     <span style={{ flexShrink: 0 }}>Execution Scope</span>
//     <strong
//       style={{
//         color: theme.primary,
//         textAlign: "right",
//         wordBreak: "break-word",
//       }}
//     >
//       Concept to Delivery
//     </strong>
//   </div>
// </div>
//           </div>

//           <div className="sidebar-cta-card">
//             <span
//               style={{
//                 fontSize: "0.75rem",
//                 color: theme.accentLight,
//                 fontWeight: "600",
//                 textTransform: "uppercase",
//                 letterSpacing: "1px",
//               }}
//             >
//               Expert Consultation
//             </span>
//             <h4
//               style={{
//                 fontSize: "1.25rem",
//                 fontWeight: "700",
//                 color: "#FFFFFF",
//                 margin: "8px 0 12px",
//                 lineHeight: "1.3",
//               }}
//             >
//               Discuss Your Project Requirements
//             </h4>
//             <p
//               style={{
//                 fontSize: "0.875rem",
//                 color: "rgba(255, 255, 255, 0.8)",
//                 lineHeight: "1.5",
//                 marginBottom: "20px",
//               }}
//             >
//               Connect with our specialized engineering team for technical evaluations and design inputs.
//             </p>

//             <button
//               onClick={() => navigate("/contact")}
//               style={{
//                 width: "100%",
//                 backgroundColor: theme.accent,
//                 color: "#FFFFFF",
//                 border: "none",
//                 padding: "12px",
//                 borderRadius: "8px",
//                 fontWeight: "600",
//                 fontSize: "0.9rem",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 gap: "8px",
//                 cursor: "pointer",
//                 transition: "background-color 0.2s ease",
//               }}
//             >
//               Contact Consultants <FiArrowRight size={14} />
//             </button>
//           </div>
//         </aside>
//       </div>

//       <Footer />
//     </div>
//   );
// };

// export default ServicePage;


import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import {
  FiCheckCircle,
  FiChevronRight,
  FiArrowRight,
  FiLayers,
  FiFileText,
} from "react-icons/fi";

const theme = {
  bgApp: "#F8FAF9",
  bgCard: "#FFFFFF",
  bgSubtle: "#F1F5F9",
  primary: "#0F172A",
  accent: "#0D9488",
  accentLight: "#CCFBF1",
  accentHover: "#0F766E",
  gold: "#D97706",
  textDark: "#1E293B",
  textMuted: "#64748B",
  border: "#E2E8F0",
  shadowSm: "0 1px 3px rgba(0, 0, 0, 0.05)",
  shadowMd: "0 10px 25px -5px rgba(0, 0, 0, 0.05), 0 8px 10px -6px rgba(0, 0, 0, 0.01)",
  shadowLg: "0 20px 25px -5px rgba(0, 0, 0, 0.08), 0 10px 10px -5px rgba(0, 0, 0, 0.02)",
};

const inlineStyles = `
  .service-page-wrapper {
    background-color: ${theme.bgApp};
    color: ${theme.textDark};
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    min-height: 100vh;
  }
  .service-hero-banner {
    position: relative;
    height: 380px;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: flex-end;
  }
  .service-hero-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, rgba(15, 23, 42, 0.3) 0%, rgba(15, 23, 42, 0.88) 100%);
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding: 40px 20px;
  }
  .service-main-layout {
    display: grid;
    grid-template-columns: 1fr 340px;
    gap: 36px;
    max-width: 1240px;
    margin: 40px auto 60px;
    padding: 0 20px;
  }
  .service-article-card {
    background-color: ${theme.bgCard};
    border-radius: 20px;
    padding: 40px;
    border: 1px solid ${theme.border};
    box-shadow: ${theme.shadowSm};
  }
  .service-bullets-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 16px;
    margin-top: 24px;
  }
  .service-bullet-card {
    background-color: ${theme.bgSubtle};
    border: 1px solid ${theme.border};
    border-radius: 12px;
    padding: 16px 20px;
    display: flex;
    align-items: flex-start;
    gap: 12px;
    transition: transform 0.2s ease, border-color 0.2s ease;
  }
  .service-bullet-card:hover {
    transform: translateY(-2px);
    border-color: ${theme.accent};
  }
  .sidebar-card-box {
    background-color: ${theme.bgCard};
    border-radius: 16px;
    padding: 28px;
    border: 1px solid ${theme.border};
    box-shadow: ${theme.shadowSm};
    margin-bottom: 24px;
  }
  .sidebar-cta-card {
    background: linear-gradient(135deg, ${theme.primary} 0%, #1E293B 100%);
    color: #FFFFFF;
    border-radius: 16px;
    padding: 28px;
    box-shadow: ${theme.shadowMd};
  }
  @media (max-width: 992px) {
    .service-main-layout {
      grid-template-columns: 1fr;
    }
  }
  @media (max-width: 600px) {
    .service-hero-banner {
      height: 280px;
    }
    .service-article-card {
      padding: 24px;
    }
    .service-bullets-grid {
      grid-template-columns: 1fr;
    }
  }
`;

// Helper: Safely parses database paragraph_highlights (handles Array, JSON string, or Comma/Newline-separated string)
const parseHighlights = (highlightsData) => {
  if (!highlightsData) return [];
  if (Array.isArray(highlightsData)) return highlightsData.filter(Boolean);

  try {
    const parsed = JSON.parse(highlightsData);
    if (Array.isArray(parsed)) return parsed.filter(Boolean);
  } catch {
    // Not valid JSON, process as string
  }

  if (typeof highlightsData === "string") {
    return highlightsData
      .split(/[\n,]/)
      .map((t) => t.trim())
      .filter((t) => t.length > 0);
  }

  return [];
};

// Helper: Matches exact-case highlights dynamically
const renderHighlightedText = (text, highlights = []) => {
  if (!text) return "";

  // 1. If line contains "Prefix: Rest", bold the prefix
  const colonIndex = text.indexOf(":");
  if (colonIndex > 0 && colonIndex < 45 && !text.includes("http")) {
    const boldPrefix = text.slice(0, colonIndex + 1);
    const rest = text.slice(colonIndex + 1);
    return (
      <>
        <strong style={{ color: theme.primary, fontWeight: 700 }}>
          {boldPrefix}
        </strong>
        {renderHighlightedText(rest, highlights)}
      </>
    );
  }

  if (!highlights || highlights.length === 0) return text;

  // Sort longest terms first so nested substrings don't break earlier
  const sortedTerms = [...highlights].sort((a, b) => b.length - a.length);
  const termsSet = new Set(sortedTerms);

  const escapedTerms = sortedTerms.map((term) =>
    term.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&")
  );

  // Exact case match - NO "i" flag
  const regex = new RegExp(`(${escapedTerms.join("|")})`, "g");
  const parts = text.split(regex);

  return parts.map((part, i) => {
    if (termsSet.has(part)) {
      return (
        <strong key={i} style={{ color: theme.primary, fontWeight: 700 }}>
          {part}
        </strong>
      );
    }
    return part;
  });
};

// Helper: Distinguishes Section Headings from Body Paragraphs
const renderParagraphContent = (paragraphData, highlights = []) => {
  if (!paragraphData) return null;

  const lines = paragraphData
    .split(/\r?\n/)
    .map((l) => l.trim())
    .filter((l) => l.length > 0);

  return lines.map((line, index) => {
    const isHeading =
      (line.length < 75 && !line.endsWith(".") && !line.endsWith(",")) ||
      line.endsWith(":");

    if (isHeading) {
      return (
        <h4
          key={index}
          style={{
            fontSize: "1.2rem",
            fontWeight: 800,
            color: theme.primary,
            marginTop: index === 0 ? "0px" : "32px",
            marginBottom: "12px",
            lineHeight: "1.4",
            borderLeft: `3px solid ${theme.accent}`,
            paddingLeft: "10px",
          }}
        >
          {line.replace(/:$/, "")}
        </h4>
      );
    }

    return (
      <p
        key={index}
        style={{
          color: theme.textMuted,
          fontSize: "1.025rem",
          lineHeight: "1.75",
          marginBottom: "18px",
        }}
      >
        {renderHighlightedText(line, highlights)}
      </p>
    );
  });
};

const ServicePage = () => {
  const { "*": path } = useParams();
  const navigate = useNavigate();
  const [service, setService] = useState(null);
  const [loading, setLoading] = useState(true);

  const slug = (path || "").split("/").pop();
  const formattedMenuName = slug.replace(/-/g, " ").toUpperCase();

  useEffect(() => {
    setLoading(true);
    fetch("https://api.info-sight.net/api/services")
      .then((res) => res.json())
      .then((data) => {
        const allowedPartial = ["ICT"];

        const matched = data.find((item) => {
          const menu = (item.menu_name || "").toUpperCase();
          const head = (item.heading || "").toUpperCase();

          if (menu === formattedMenuName) return true;
          if (head === formattedMenuName) return true;

          if (allowedPartial.includes(formattedMenuName)) {
            return head.includes(formattedMenuName);
          }

          return false;
        });

        setService(matched || null);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error loading service data:", err);
        setLoading(false);
      });
  }, [formattedMenuName]);

  const getParsedBullets = (bulletData) => {
    if (!bulletData) return [];
    try {
      if (Array.isArray(bulletData)) return bulletData;
      const parsed = JSON.parse(bulletData);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return typeof bulletData === "string"
        ? bulletData.split("\n").filter((b) => b.trim().length > 0)
        : [];
    }
  };

  if (loading) {
    return (
      <div className="service-page-wrapper">
        <Navbar />
        <div style={{ padding: "120px 20px", textAlign: "center", color: theme.textMuted }}>
          <div
            style={{
              width: "40px",
              height: "40px",
              border: `3px solid ${theme.border}`,
              borderTopColor: theme.accent,
              borderRadius: "50%",
              animation: "spin 0.8s linear infinite",
              margin: "0 auto 16px",
            }}
          />
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
          <p style={{ fontSize: "1rem", fontWeight: "500" }}>Loading service specifications...</p>
        </div>
        <Footer />
      </div>
    );
  }

  if (!service) {
    return (
      <div className="service-page-wrapper">
        <Navbar />
        <div style={{ padding: "120px 20px", textAlign: "center", maxWidth: "600px", margin: "0 auto" }}>
          <FiFileText size={48} color={theme.textMuted} style={{ marginBottom: "16px" }} />
          <h2 style={{ fontSize: "1.5rem", fontWeight: "700", color: theme.primary }}>
            Service Specification Not Found
          </h2>
          <p style={{ color: theme.textMuted, margin: "12px 0 24px" }}>
            The requested service details could not be retrieved. Please check the menu link or return home.
          </p>
          <button
            onClick={() => navigate("/")}
            style={{
              backgroundColor: theme.accent,
              color: "#FFF",
              border: "none",
              padding: "12px 24px",
              borderRadius: "8px",
              fontWeight: "600",
              cursor: "pointer",
            }}
          >
            Return to Homepage
          </button>
        </div>
        <Footer />
      </div>
    );
  }

  const rawBullets = getParsedBullets(service.bullet_points);
  const highlights = parseHighlights(service.paragraph_highlights);

  return (
    <div className="service-page-wrapper">
      <style>{inlineStyles}</style>
      <Navbar />

      {/* Hero Banner Section */}
      <section
        className="service-hero-banner"
        style={{ backgroundImage: `url(${service.image})` }}
      >
        <div className="service-hero-overlay">
          <div style={{ maxWidth: "1240px", width: "100%", margin: "0 auto" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                color: "rgba(255,255,255,0.8)",
                fontSize: "0.85rem",
                marginBottom: "12px",
              }}
            >
              <span style={{ cursor: "pointer" }} onClick={() => navigate("/")}>
                Home
              </span>
              <FiChevronRight size={12} />
              <span style={{ cursor: "pointer" }} onClick={() => navigate("/#services")}>
                Services
              </span>
              <FiChevronRight size={12} />
              <span style={{ color: theme.accentLight, fontWeight: "600" }}>
                {service.heading}
              </span>
            </div>

            <h1
              style={{
                color: "#FFFFFF",
                fontSize: "2.25rem",
                fontWeight: "800",
                lineHeight: "1.2",
              }}
            >
              {service.heading}
            </h1>
          </div>
        </div>
      </section>

      {/* Main Content Split Layout */}
      <div className="service-main-layout">
        {/* Left Article Body */}
        <article className="service-article-card">
          <span
            style={{
              color: theme.accent,
              fontWeight: "600",
              fontSize: "0.825rem",
              letterSpacing: "1.2px",
              textTransform: "uppercase",
              backgroundColor: theme.accentLight,
              padding: "6px 14px",
              borderRadius: "20px",
              display: "inline-block",
              marginBottom: "16px",
            }}
          >
            Engineering Deliverables
          </span>

          <h2
            style={{
              fontSize: "1.75rem",
              fontWeight: "800",
              color: theme.primary,
              marginBottom: "24px",
              lineHeight: "1.3",
            }}
          >
            {service.heading}
          </h2>

          {/* Formatted Paragraphs with Dynamic Database Highlights */}
          <div style={{ marginBottom: "32px" }}>
            {renderParagraphContent(service.paragraph, highlights)}
          </div>

          {/* Bullet Deliverables Section */}
          {rawBullets.length > 0 && (
            <div style={{ paddingTop: "24px", borderTop: `1px solid ${theme.border}` }}>
              <h3
                style={{
                  fontSize: "1.2rem",
                  fontWeight: "700",
                  color: theme.primary,
                  marginBottom: "16px",
                }}
              >
                Key Scope & Technical Capabilities
              </h3>

              <div className="service-bullets-grid">
                {rawBullets.map((item, index) => {
                  const cleanedText = item.replace(/^[•\t\s*]+/g, "").trim();

                  const isInnerHeading =
                    !item.startsWith("•") &&
                    !item.startsWith("\t") &&
                    cleanedText.length < 60 &&
                    !cleanedText.endsWith(".");

                  if (isInnerHeading) {
                    return (
                      <div
                        key={index}
                        style={{
                          gridColumn: "1 / -1",
                          marginTop: "16px",
                          marginBottom: "4px",
                        }}
                      >
                        <h4
                          style={{
                            fontSize: "1.1rem",
                            fontWeight: "800",
                            color: theme.primary,
                          }}
                        >
                          {cleanedText}
                        </h4>
                      </div>
                    );
                  }

                  return (
                    <div key={index} className="service-bullet-card">
                      <FiCheckCircle
                        size={20}
                        color={theme.accent}
                        style={{ flexShrink: 0, marginTop: "2px" }}
                      />
                      <span
                        style={{
                          fontSize: "0.925rem",
                          color: theme.textDark,
                          fontWeight: "500",
                          lineHeight: "1.5",
                        }}
                      >
                        {renderHighlightedText(cleanedText, highlights)}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </article>

        {/* Right Sidebar Controls */}
        <aside>
          <div className="sidebar-card-box">
            <h3
              style={{
                fontSize: "1.1rem",
                fontWeight: "700",
                color: theme.primary,
                marginBottom: "16px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <FiLayers color={theme.accent} /> Service Overview
            </h3>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "22px",
                fontSize: "0.9rem",
                color: theme.textMuted,
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  gap: "16px",
                  paddingBottom: "10px",
                  borderBottom: `1px solid ${theme.border}`,
                }}
              >
                <span style={{ flexShrink: 0 }}>Category</span>
                <strong
                  style={{
                    color: theme.primary,
                    textAlign: "right",
                    wordBreak: "break-word",
                  }}
                >
                  {service.menu_name_ || "LEED, BREEAM, ESTIDAMA, MOSTADAM, WELL"}
                </strong>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  gap: "16px",
                  paddingBottom: "10px",
                  borderBottom: `1px solid ${theme.border}`,
                }}
              >
                <span style={{ flexShrink: 0 }}>Standard Compliance</span>
                <strong
                  style={{
                    color: theme.primary,
                    textAlign: "right",
                    wordBreak: "break-word",
                  }}
                >
                  Global Standards
                </strong>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  gap: "16px",
                }}
              >
                <span style={{ flexShrink: 0 }}>Execution Scope</span>
                <strong
                  style={{
                    color: theme.primary,
                    textAlign: "right",
                    wordBreak: "break-word",
                  }}
                >
                  Concept to Delivery
                </strong>
              </div>
            </div>
          </div>

          <div className="sidebar-cta-card">
            <span
              style={{
                fontSize: "0.75rem",
                color: theme.accentLight,
                fontWeight: "600",
                textTransform: "uppercase",
                letterSpacing: "1px",
              }}
            >
              Expert Consultation
            </span>
            <h4
              style={{
                fontSize: "1.25rem",
                fontWeight: "700",
                color: "#FFFFFF",
                margin: "8px 0 12px",
                lineHeight: "1.3",
              }}
            >
              Discuss Your Project Requirements
            </h4>
            <p
              style={{
                fontSize: "0.875rem",
                color: "rgba(255, 255, 255, 0.8)",
                lineHeight: "1.5",
                marginBottom: "20px",
              }}
            >
              Connect with our specialized engineering team for technical evaluations and design inputs.
            </p>

            <button
              onClick={() => navigate("/contact")}
              style={{
                width: "100%",
                backgroundColor: theme.accent,
                color: "#FFFFFF",
                border: "none",
                padding: "12px",
                borderRadius: "8px",
                fontWeight: "600",
                fontSize: "0.9rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                cursor: "pointer",
                transition: "background-color 0.2s ease",
              }}
            >
              Contact Consultants <FiArrowRight size={14} />
            </button>
          </div>
        </aside>
      </div>

      <Footer />
    </div>
  );
};

export default ServicePage;